// extracted by mini-css-extract-plugin
module.exports = {"header":"Question_header__153R-"};